import { DataUsageTotals } from "@preveil-api";
import { ChartDataInput, AdminDashboardLimits, DashboardChartTitles } from "src/common";
import { filesize } from "filesize";
// Dashboard classes
// -------------------------------------------------------------
// Description: Calculate usage for Dashboard totals and used

export class DashboardUsage {
    available: number = AdminDashboardLimits.TOTAL_STORAGE_AVAILABLE;
    used!: number;
    private!: number;
    shared!: number;
    _default_collection_used!: number;

    constructor(public usage: DataUsageTotals) {
        this._calculateTotals(usage);
    }

    // Description: Calculate different usage for the drive storage totals.
    private _calculateTotals(usage: DataUsageTotals) {
        this.available = usage.maximum_allowed_data_usage || AdminDashboardLimits.TOTAL_STORAGE_AVAILABLE;
        this.shared = Number(usage.shared_collections?.active_bytes ?? 0) + Number(usage.shared_collections?.deleted_bytes ?? 0) + Number(usage.shared_collections?.versioned_bytes ?? 0);
        this._default_collection_used = Number(usage.default_collections?.active_bytes ?? 0) + Number(usage.default_collections?.deleted_bytes ?? 0) + Number(usage.default_collections?.versioned_bytes ?? 0);
        this.used = Number(this._default_collection_used + this.shared);
        this.private = Number(this.used - this.shared);
    }

    // Description: return totals data for chart
    get totals_data(): ChartDataInput[] {
        return [
            {
                name: DashboardChartTitles.available,
                value: this.available
            },
            {
                name: DashboardChartTitles.used,
                value: this.used
            }
        ];
    }

    // Description: return used data for chart
    get used_data() {
        return [
            {
                name: DashboardChartTitles.private,
                value: this.private
            },
            {
                name: DashboardChartTitles.shared,
                value: this.shared
            }
        ];
    };

    // Description: return totals and calculated cumulative data
    get cumulative_data() {
        return {
            totals: this.totals_data,
            used: this.used_data
        };
    }

    // Description: Parse the number to a user friendly label
    static convertUsageToFriendlySize(value: number): string {
        return !!value ? filesize(Number(value).toFixed(1)) : "Empty";
    }

    // Description: Parse the number to a user friendly label in ListView
    static convertUsageToFriendlySizeList(value: number): string {
        return !!value ? filesize(Number(value).toFixed(1)) : "-";
    }

    // Description: Parse the number to a percentage 
    static convertUsageToPercentUsed(value: number, total: number): string {
        const percent = (value / total * 100);
        return !!value ? `${percent < 1 ? "< 1" : percent.toFixed(2)} %` : "Empty";
    }
}
